(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hgs-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.hgsGalleryLightbox) return;
  window.hgsGalleryLightbox = true;

  function init() {
    var grids = document.querySelectorAll('.hgs-gallery__grid');
    if (!grids.length) return;

    var ov = document.createElement('div');
    ov.className = 'hgs-lightbox';
    ov.setAttribute('aria-hidden', 'true');
    ov.innerHTML =
      '<button class="hgs-lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="hgs-lightbox__nav hgs-lightbox__prev" type="button" aria-label="Previous photo">&#8249;</button>' +
      '<img class="hgs-lightbox__img" alt="">' +
      '<button class="hgs-lightbox__nav hgs-lightbox__next" type="button" aria-label="Next photo">&#8250;</button>';
    document.body.appendChild(ov);

    var ovImg = ov.querySelector('.hgs-lightbox__img');
    var group = [], idx = 0, lastFocus = null;

    function show(i) {
      idx = (i + group.length) % group.length;
      var tile = group[idx];
      ovImg.src = tile.getAttribute('data-full') || tile.querySelector('img').src;
      var img = tile.querySelector('img');
      ovImg.alt = img ? (img.alt || '') : '';
    }
    function open(tiles, i) {
      group = tiles;
      lastFocus = document.activeElement;
      show(i);
      ov.classList.add('is-open');
      ov.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      ov.querySelector('.hgs-lightbox__close').focus();
    }
    function close() {
      ov.classList.remove('is-open');
      ov.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      ovImg.src = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    grids.forEach(function (grid) {
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('.hgs-gallery__zoom'));
      tiles.forEach(function (t, i) {
        t.addEventListener('click', function () { open(tiles, i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(tiles, i); }
        });
      });
    });

    ov.querySelector('.hgs-lightbox__close').addEventListener('click', close);
    ov.querySelector('.hgs-lightbox__prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    ov.querySelector('.hgs-lightbox__next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
